/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationDevelopmentState
 */
export interface LocationDevelopmentState {
    /**
     * 
     * @type {number}
     * @memberof LocationDevelopmentState
     */
    locationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDevelopmentState
     */
    isDevelopment: boolean;
}

/**
 * Check if a given object implements the LocationDevelopmentState interface.
 */
export function instanceOfLocationDevelopmentState(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "isDevelopment" in value;

    return isInstance;
}

export function LocationDevelopmentStateFromJSON(json: any): LocationDevelopmentState {
    return LocationDevelopmentStateFromJSONTyped(json, false);
}

export function LocationDevelopmentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationDevelopmentState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'isDevelopment': json['isDevelopment'],
    };
}

export function LocationDevelopmentStateToJSON(value?: LocationDevelopmentState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'isDevelopment': value.isDevelopment,
    };
}

